import {ACTION_CODE} from './_actionCode';
import {DealDasService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
import { UserState } from '../../reducers/UserReducer';

const FUNCTION_CODE = 'GET_ALL_DEAL_DAS';

export async function getAllDealDas(
    userData: UserState["userProfileData"],
    params = '',
    page = 1
) {
    try {
        LoggerService.logInfo('Action - getAllDealDas - Start');

        const getAllDealDasResult = await DealDasService.getAllDealDas(userData?.userToken as string, params, page);

        LoggerService.logInfo('Action - getAllDealDas - Success');

        return ResultModel.newSuccessResult(getAllDealDasResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - getAllDealDas - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récupération de la liste des domaines d\'activités des affaires',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
